import React from "react";
import "../css/style.css";

import i18next from "i18next";
import CookieConsent from "react-cookie-consent";
import { landingDomain } from "../_constants";

export default class CookiePopup extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    // Китайская сборка — мобильное приложение, а не сайт: баннер про cookie там
    // неуместен и вдобавок ведёт на страницы лендинга, которых в китайском
    // контуре нет (пункт 34 QA-таблицы). В обычной сборке ничего не меняется.
    if (process.env.REACT_APP_CHINA_MODE === "true") return null;

    return (
      <CookieConsent
        location="bottom"
        buttonText={i18next.t("i_agree")}
        cookieName="myAwesomeCookieName2"
        containerClasses="cookie-consent"
        contentClasses="cookie-consent__content"
        buttonWrapperClasses="cookie-consent__buttons"
        expires={150}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
          padding: "10px 20px",
          // Выше виджета чата (у LHC 2147483640): кнопка чата стоит в том же углу
          // и иначе накрывает «Согласен» — согласие дать нельзя, плашка не уходит.
          zIndex: 2147483647,
          background: "#2B373B" 
        }}
        buttonStyle={{
          backgroundColor: "#33AFEE",
          color: "#4e503b", 
          flex: "0 0 auto",
          fontSize: "13px"
        }}
      >
        {i18next.t("cookie_1")}{" "}
        <a
          href={`https://${landingDomain}/cookie-agreement/`}
          target="_blank"
          rel="nofollow"
          rel="noindex"
        >
          <span style={{ textDecoration: "underline" }}>{i18next.t("cookie_2")}</span>
        </a>{" "}
        {i18next.t("cookie_3")}{" "}
        <a
          href={`https://${landingDomain}/cookie/`}
          target="_blank"
          rel="nofollow"
          className="hrefline"
        >
          <span style={{ textDecoration: "underline" }}>cookie</span>
        </a>
      </CookieConsent>
    );
  }
}
